import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const onestepConfig: TSPConfig = {
  key: 'onestep',
  name: 'OneStepGPS',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>
        Please request an API key from{' '}
        <a
          href='mailto:integration@onestepgps.com'
          target='_blank'
          rel='noreferrer'
        >
          integration@onestepgps.com
        </a>
        . Then, input that key here.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default onestepConfig;
